import Alpine from 'alpinejs';
import { msg } from '../main';

export const INIT_cart = () => {
  // On load
  window.addEventListener('load', () => {
    const stepCurr = Number(Alpine.store('configurator').step);
    const formConfigurator = document.getElementById('pb-configurator');

    if (
      [1, 2, 4, 5].includes(stepCurr) &&
      !document.body.classList.contains('has-cart') &&
      formConfigurator
    ) {
      updateMiniCart();

      if (window.jQuery) {
        jQuery(document.body).on('updated_cart_totals', () => {
          updateMiniCart();
        });

        jQuery(document).ready(() => {
          if (window.location.href.indexOf('/checkout/order-received/') > -1) {
            updateMiniCart();
          }
        });
      }
    }

    // document.body.classList.remove('is-loading');
  });

  window.addEventListener(
    'click',
    event => {
      // Update cart
      if (event.target.classList.contains('js--update-cart')) {
        const btn = event.target;
        const alertMessages = JSON.parse(btn.dataset.alerts);

        btn.blur();

        document.body.classList.add('is-loading');

        fetch(btn.dataset.url)
          .then(response => {
            msg.flash(alertMessages.valid, true);

            if (response.status !== 200) {
              msg.flash(alertMessages.invalid, false);
            }

            updateMiniCart();
          })
          .catch(error => {
            console.error('Error:', error);
          });
      }

      // Update coupon
      if (event.target.classList.contains('js--update-coupon')) {
        const btn = event.target;
        const action = btn.dataset.action;

        let coupon_code = document.getElementById('form-configurator-promo');
        let wc_nonce_coupon = document.querySelector(
          'meta[name=wc_nonce_coupon_apply]'
        )
          ? document.querySelector('meta[name=wc_nonce_coupon_apply]').content
          : null;

        let data = {
          coupon_code: coupon_code.value,
          security: wc_nonce_coupon,
        };

        if (action === 'remove') {
          coupon_code = btn.dataset.code;
          wc_nonce_coupon = document.querySelector(
            'meta[name=wc_nonce_coupon_remove]'
          )
            ? document.querySelector('meta[name=wc_nonce_coupon_remove]')
                .content
            : null;

          data = {
            coupon: coupon_code,
            security: wc_nonce_coupon,
          };
        }

        btn.blur();

        document.body.classList.add('is-loading');

        jQuery.post(`/?wc-ajax=${action}_coupon`, data).done(data => {
          const dataDom = new DOMParser().parseFromString(data, 'text/html');
          const msgWrapper = dataDom.querySelector('[role=alert]');

          let msgItem = msgWrapper.querySelector('li');

          if (msgItem) {
            msgItem = msgItem.innerHTML.trim();
          } else {
            msgItem = msgWrapper.innerHTML.trim();
          }

          let msgType = true;

          if (msgWrapper.classList.contains('woocommerce-error')) {
            msgType = false;
          }

          updateMiniCart();
          coupon_code.value = '';
          msg.flash(msgItem, msgType);
        });
      }

      // Add to cart simple product
      if (event.target.classList.contains('js--add-to-cart--simple')) {
        const btn = event.target;
        const id = btn.dataset.id;
        const quantity = document.querySelector(
          `#form-product-custom-quantity-${id}`
        ).value;
        const alertMessages = JSON.parse(btn.dataset.alerts);

        btn.blur();

        document.body.classList.add('is-loading');

        addItem(
          id,
          quantity,
          null,
          () => msg.flash(alertMessages.valid, true),
          () => msg.flash(alertMessages.invalid, false),
          () => {
            window.location.href = '/';
          }
        );
      }

      // Add to cart upsell product
      if (event.target.classList.contains('js--add-to-cart--upsell')) {
        const btn = event.target;
        const id = btn.dataset.id;
        const quantity = document.querySelector(
          `#form-product-upsell-quantity-${id}`
        ).value;
        const alertMessages = JSON.parse(btn.dataset.alerts);

        btn.blur();

        document.body.classList.add('is-loading');

        addItem(
          id,
          quantity,
          null,
          () => msg.flash(alertMessages.valid, true),
          () => msg.flash(alertMessages.invalid, false),
        );
      }

      // Upgrade product
      if (event.target.classList.contains('js--upgrade-product')) {
        const btn = event.target;
        const alertMessages = JSON.parse(btn.dataset.alerts);

        btn.blur();

        document.body.classList.add('is-loading');

        fetch(btn.dataset.remove)
          .then(response => {
            if (response.status !== 200) {
              msg.flash(alertMessages.invalid, false);
            } else {
              addItem(
                btn.dataset.variation,
                btn.dataset.quantity,
                null,
                () => msg.flash(alertMessages.valid, true),
                () => msg.flash(alertMessages.invalid, false),
              );
            }
          })
          .catch(error => {
            console.error('Error:', error);
          });
      }
    },
    false
  );
};

/*
 * updateMiniCart
 */

export async function updateMiniCart(onSuccess = null) {
  document.body.classList.add('is-loading');

  fetch('/ajax-cart/')
    .then(response => response.text())
    .then(html => {
      const htmlDom = new DOMParser().parseFromString(html, 'text/html');
      const listItemsD = [...htmlDom.querySelectorAll('.desktop tr')];
      const listItemsM = [
        ...htmlDom.querySelectorAll('.mobile .g-configurator--cart--item'),
      ];

      // Redirect to Step 1 if cart is empty
      const stepCurr = Number(Alpine.store('configurator').step);

      if (!listItemsD.length && stepCurr !== 1) {
        Alpine.store('configurator', {
          step: 1,
          substep: 0,
        });
      }

      // Redirect to Step 1 if cart doesn't contain Trees and current step is 2
      if (stepCurr === 2 && document.body.dataset.nextStep === '3') {
        Alpine.store('configurator', {
          step: 1,
          substep: 0,
        });
      }

      // Desktop version
      const cartsD = [
        ...document.querySelectorAll('.g-configurator--cart.cart-desktop'),
      ];

      if (cartsD.length) {
        if (htmlDom.querySelector('.desktop')) {
          document.body.dataset.nextStep =
            htmlDom.querySelector('.desktop').dataset.nextStep;
          document.body.dataset.nextSubstep =
            htmlDom.querySelector('.desktop').dataset.nextSubstep;
        }

        cartsD.forEach(cart => {
          const list = cart.querySelector('tbody');

          list.innerHTML = '';

          if (listItemsD.length) {
            listItemsD.forEach(listItem => {
              list.insertAdjacentHTML('beforeend', listItem.outerHTML);
            });
          }
        });
      }

      // Mobile version
      const cartsM = [
        ...document.querySelectorAll('.g-configurator--cart.cart-mobile'),
      ];

      if (cartsM.length) {
        cartsM.forEach(cart => {
          cart.innerHTML = '';

          if (listItemsM.length) {
            listItemsM.forEach(listItem => {
              cart.insertAdjacentHTML('beforeend', listItem.outerHTML);
            });
          }
        });
      }

      // Subtotal
      let subtotal = [
        ...document.querySelectorAll('.g-configurator--controls .subtotal'),
        ...document.querySelectorAll(
          '.g-configurator--table--review--item .subtotal'
        ),
      ];

      if (subtotal.length) {
        subtotal.forEach(item => {
          const value = htmlDom.querySelector('.totals .subtotal');

          item.innerHTML = '';

          if (value) {
            item.innerHTML = value.innerHTML;
          }
        });
      }

      // Total no VAT
      let total_no_vat = [
        ...document.querySelectorAll('.g-configurator--controls .total_no_vat'),
        ...document.querySelectorAll(
          '.g-configurator--table--review--item .total_no_vat'
        ),
      ];

      if (total_no_vat.length) {
        total_no_vat.forEach(item => {
          const value = htmlDom.querySelector('.totals .total_no_vat');

          item.innerHTML = '';

          if (value) {
            item.innerHTML = value.innerHTML;
          }
        });
      }

      // VAT
      let vat = [
        ...document.querySelectorAll('.g-configurator--controls .vat'),
        ...document.querySelectorAll(
          '.g-configurator--table--review--item .vat'
        ),
      ];

      if (vat.length) {
        vat.forEach(item => {
          const value = htmlDom.querySelector('.totals .vat');

          item.innerHTML = '';

          if (value) {
            item.innerHTML = value.innerHTML;
          }
        });
      }

      // Total
      let total = [
        ...document.querySelectorAll('.g-configurator--controls .total'),
        ...document.querySelectorAll(
          '.g-configurator--table--review--item .total'
        ),
      ];

      if (total.length) {
        total.forEach(item => {
          const value = htmlDom.querySelector('.totals .total');

          item.innerHTML = '';

          if (value) {
            item.innerHTML = value.innerHTML;
          }
        });
      }

      // Coupons
      let coupons = [
        ...document.querySelectorAll(
          '.g-configurator--table--review--item .coupons'
        ),
      ];

      if (coupons.length) {
        coupons.forEach(item => {
          const value = htmlDom.querySelector('.totals .coupons');

          item.innerHTML = '';

          if (value) {
            item.innerHTML = value.innerHTML;
          }
        });
      }

      let couponsControls = [
        ...document.querySelectorAll('.g-configurator--controls--top--totals'),
      ];

      if (couponsControls.length) {
        couponsControls.forEach(item => {
          const wrapperLabels = item.querySelector('.coupon-labels');
          const wrapperValues = item.querySelector('.coupon-values');
          const labels = htmlDom.querySelector('.totals .coupon-labels');
          const values = htmlDom.querySelector('.totals .coupon-values');

          wrapperLabels.innerHTML = '';
          wrapperValues.innerHTML = '';

          if (labels && values) {
            wrapperLabels.innerHTML = labels.innerHTML;
            wrapperValues.innerHTML = values.innerHTML;
          }
        });
      }

      // Order triggers enable/disable
      if (listItemsD.length) {
        const orderTriggers = [
          ...document.querySelectorAll(
            '.g-configurator--controls--bottom button'
          ),
        ];

        if (orderTriggers.length) {
          orderTriggers.forEach(btn => {
            btn.classList.remove('is-disabled');
            btn.disabled = false;
          });
        }

        document.body.classList.remove('is-loading');
      } else {
        const orderTriggers = [
          ...document.querySelectorAll(
            '.g-configurator--controls--bottom button'
          ),
        ];

        if (orderTriggers.length) {
          orderTriggers.forEach(btn => {
            btn.classList.add('is-disabled');
            btn.disabled = true;
          });
        }

        document.body.classList.remove('is-loading');
      }

      // Remove Garlands and Wreaths when necessary
      const garlands = [...document.querySelectorAll('[data-type="Garland"]')];
      const wreaths = [...document.querySelectorAll('[data-type="Wreath"]')];
      const gw = garlands.concat(wreaths);

      if (gw.length && document.body.dataset.nextStep === '3') {
        document.body.classList.add('is-loading');

        gw[0].querySelector('.g-configurator--cart--remove').click();
      }

      // Success Callback
      if (onSuccess) {
        onSuccess();
      }
    })
    .catch(error => {
      console.error('Error:', error);
    })
    .finally(() => {
      document.body.classList.add('has-cart');
    });
}

/*
 * updateQuantity
 */

window.addEventListener(
  'click',
  event => {
    if (event.target.classList.contains('js-update-quantity')) {
      const target = event.target;
      const item = target.closest('.g-configurator--cart--item');

      target.blur();

      setTimeout(() => {
        const id = item.dataset.variation;
        let quantity = item.querySelector(
          `#form-configurator-product-${id}-quantity`
        );

        if (quantity) {
          quantity = quantity.value;
        } else {
          quantity = item.querySelector(
            `#form-configurator-product-${id}-quantity-mobile`
          ).value;
        }

        if (quantity > 0) {
          const alertMessages = JSON.parse(item.dataset.alerts);

          document.body.classList.add('is-loading');

          addItem(
            id,
            target.classList.contains('g-input-quantity--minus') ? -1 : 1,
            null,
            () => msg.flash(alertMessages.valid, true),
            () => msg.flash(alertMessages.invalid, false)
          );
        }
      }, 100);
    }
  },
  false
);

/*
 * addToCart
 */

export async function addToCart(
  product_type,
  product_id,
  attributes,
  c_bespoke = null,
  quantity,
  onSuccess,
  onError
) {
  // Variation
  if (product_type === 'variation') {
    const app_url = document.querySelector('meta[name=app_url]')
      ? document.querySelector('meta[name=app_url]').content
      : null;

    fetch(`${app_url}/routes/variations`, {
      method: 'POST',
      mode: 'cors',
      cache: 'no-cache',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
      },
      redirect: 'follow',
      referrerPolicy: 'no-referrer',
      body: JSON.stringify({
        product_id: product_id,
        attributes: attributes,
      }),
    })
      .then(response => response.json())
      .then(data => {
        addItem(data.variation_id, quantity, c_bespoke, onSuccess, onError);
      })
      .catch(error => {
        console.error('Error:', error);
      });
  }

  // Simple
  if (product_type === 'simple') {
    addItem(product_id, quantity, null, onSuccess, onError);
  }
}

export async function addItem(
  id,
  quantity,
  c_bespoke = null,
  onSuccess,
  onError,
  callback = null
) {
  const app_url = document.querySelector('meta[name=app_url]')
    ? document.querySelector('meta[name=app_url]').content
    : null;
  const wc_nonce = document.querySelector('meta[name=wc_nonce]')
    ? document.querySelector('meta[name=wc_nonce]').content
    : null;

  let fetchBody = {
    id: id,
    quantity: quantity,
  };

  if (c_bespoke) {
    fetchBody = {
      id: id,
      quantity: quantity,
      variation: [
        {
          attribute: 'custom_colours',
          value: c_bespoke,
        },
      ],
    };
  }

  fetch(`${app_url}/wp-json/wc/store/cart/add-item`, {
    method: 'POST',
    mode: 'cors',
    cache: 'no-cache',
    credentials: 'same-origin',
    headers: {
      Nonce: wc_nonce,
      'X-WC-Store-API-Nonce': wc_nonce,
      'Content-Type': 'application/json',
    },
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
    body: JSON.stringify(fetchBody),
  })
    .then(response => {
      if (response.status > 199 && response.status < 300) {
        updateMiniCart(onSuccess);
      } else {
        onError();
      }
    })
    .catch(error => {
      console.error('Error:', error);
    })
    .finally(() => {
      if (callback) {
        callback();
      }
    });
}



window.addEventListener('change', event => {
  if (event.target.classList.contains('js--product-upsell-attribute-dropdown')) {
    const form = event.target.closest('.js--product-upsell-form');

    if (form) {
      const selects = form.querySelectorAll('.js--product-upsell-attribute-dropdown');

      if (selects) {
        let values = [];

        [...selects].forEach(select => {
          if (select.value !== '') {
            values.push(select.value);
          }
        });

        if (values.length === [...selects].length) {
          const variations = form.querySelectorAll('.js--product-upsell-variation');

          if (variations) {
            [...variations].forEach(variation => {
              const variationAttributes = JSON.parse(variation.dataset.variationAttributes);

              if (variationAttributes.sort().join(',') === values.sort().join(',')) {
                const variationId = variation.dataset.variationId;
                const variationPrice = variation.dataset.variationPrice;

                form.querySelector('.product-custom--form--desc strong span').innerHTML = variationPrice;
                form.querySelector('.product-custom--form--desc').classList.remove('is-hidden');

                form.querySelector('.js--product-upsell-quantity').id = `form-product-upsell-quantity-${variationId}`;
                form.querySelector('.js--product-upsell-quantity').disabled = false;

                form.querySelector('.js--add-to-cart--upsell').dataset.id = variationId;
                form.querySelector('.js--add-to-cart--upsell').disabled = false;
              }
            });
          }
        } else {
          form.querySelector('.product-custom--form--desc').classList.add('is-hidden');

          form.querySelector('.js--product-upsell-quantity').disabled = true;
          form.querySelector('.js--product-upsell-quantity').value = 1;

          form.querySelector('.js--add-to-cart--upsell').disabled = true;
        }
      }
    }
  }
});
